const SearchFormLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "TransactionDateFrom",
                "tableName": "",
                "label": "Tran Date From",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            },
            {
                "name": "R_CUSTOMER",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Customer:",
                "type": "select",
                "options": [""],
                "apiUrl": "om/SaleOrder/GetCustomers",
                "grid": null,
                "required": false,
                "visible": true
            }

        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "TransactionDateTo",
                "tableName": "",
                "label": "Tran Date To",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            },
            {
                "name": "R_Item",
                "tableName": "OMTransactionDetail",
                "label": "Item:",
                "type": "select",
                "options": [""],
                "apiUrl": "om/Transaction/GetItems",
                "grid": null,
                "required": false,
                "visible": true
            }


        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "TRANSACTIONNUMBER",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Transaction #",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            },
            {
                "name": "R_Lot",
                "tableName": "OMTransactionDetail",
                "label": "Lot:",
                "type": "select",
                "options": [""],
                "apiUrl": "om/Transaction/GetLots",
                "grid": null,
                "required": false,
                "visible": true
            }


        ]
    },
    {
        "groupId": 4,
        "label": "",
        "fields": [
            {
                "name": "R_Warehouse",
                "tableName": "OMTransactionDetail",
                "label": "Warehouse:",
                "type": "select",
                "options": [""],
                "apiUrl": "om/SaleOrder/GetWareHouses",
                "grid": null,
                "required": false,
                "visible": true
            }

        ]
    }
];
export default SearchFormLayout;